import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useTaskAnalysis } from "../../Hooks/Features/ProjectGlance/useTaskAnalysis"

const TaskAnalysis = ({ projectId }) => {

    const tab = "";
    const { showDetails, setShowDetails, tabs } = useTaskAnalysis({ projectId, tab });

    return (
        <div className="w100">
            <div className="d-flex align-items-center justify-content-between p-1 pb-2">
                <div className="fs-6 fw-semibold d-flex gap-2 align-items-center">
                    <FontAwesomeIcon icon="fa-solid fa-chart-line" />
                    Task Analysis
                </div>
                <div className="c-pointer text-primary" onClick={() => setShowDetails((prev) => ({ ...prev, visible: !showDetails?.visible }))}>{showDetails?.visible ? "Hide Details" : "Show Details"}</div>
            </div>
            {showDetails?.visible &&
                <div className="w100">
                    <div className="border-top border-bottom py-2 mt-2">
                        <div className="d-flex gap-2">
                            {tabs?.map(item => (
                                <div key={item?.key} className={`border c-pointer px-2 rounded-pill  ${showDetails?.tab?.key === item?.key ? "bg-black text-white fw-semibold" : ""}`} style={{ paddingTop: "2px", paddingBottom: "2px" }} onClick={() => setShowDetails((prev) => ({ ...prev, tab: item }))}>{item?.label}</div>
                            ))}
                        </div>
                    </div>
                    <div className="p-2 w100" style={{ height: "40vh" }}>
                        {showDetails?.tab?.component}
                    </div>
                </div>
            }
        </div>
    )
}

export default TaskAnalysis